export default __webpack_public_path__ + "locales/pt-BR/SocialAuthWelcomeDialog.json?hash=24cd3fa67e3cf3a57a7bb731dd91e433";